module.exports = __webpack_public_path__ + "static/img_9646-55849ad92ffedbf95e193cfbd4d1bee3.webp";